export const isEmail = (maybeEmail) => {
  /* eslint-disable no-useless-escape */
  const mailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  /* eslint-enable no-useless-escape */
  if (maybeEmail.match(mailRegex)) {
    return true;
  }
  return false;
};
